import { MandatoryService } from '@/actions/fetchAmcServiceDetails';
import { AssetsData } from '@/types/asset';
import { AMCServiceDetailsItemType } from './amcServiceDetails';
import date from '@/utils/date';

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const options = { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'Asia/Kolkata' };
  return date.toLocaleDateString('en-US', options as any);
};

export interface MyDevicesProps {
  productsData: AssetsData[];
  showBookServiceCta?: boolean;
}

const PlanTypeStatusMapping = {
  COMPREHENSIVE: 'comprehensive',
  GOLD: 'gold',
  PLATINUM: 'platinum',
  SILVER: 'silver',
  VALUE: 'value',
  WARRANTY: 'warranty',
};

export const getPlanType = (status: string, planType: string) => {
  if (status === 'In Warranty' || status === 'Warranty Expiring') {
    return PlanTypeStatusMapping.COMPREHENSIVE;
  }
  if (status === 'AMC Expiring' || status === 'AMC Tier' || status === '') {
    if (planType === 'COMP') {
      return PlanTypeStatusMapping.COMPREHENSIVE;
    }
  }
  return planType;
};

export const getStatus = (label: string) => {
  if (label === 'In Warranty' || label === 'Warranty Expiring') {
    return PlanTypeStatusMapping.WARRANTY;
  }
  return label;
};

export const convertTimeStamp = (timestamp: string, serviceStatus: boolean) => {
  if (!timestamp) {
    return null;
  }

  const inputDate = new Date(timestamp);

  const hour = inputDate.getUTCHours();
  const formattedMinute = inputDate.getUTCMinutes().toString().padStart(2, '0');
  const convertedTime = `, ${hour % 12 === 0 ? 12 : hour % 12}:${formattedMinute} ${
    hour < 12 ? 'AM' : 'PM'
  }`;

  return `${date.format(timestamp, { month: 'short' })} ${serviceStatus ? convertedTime : ''}`;
};

export const converToAMCServiceDetails = (mandatoryServices: MandatoryService[]) => {
  let amcDetails: AMCServiceDetailsItemType[] = [];

  mandatoryServices.map((service: any, index: number) => {
    const { isAvailed, bookingDate, description } = service;
    amcDetails.push({
      display_order: index + 1,
      details: {
        status: isAvailed,
        desc: description,
        timestamp: bookingDate,
      },
    });
  });

  return amcDetails;
};
